// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import {Loading} from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import echarts from 'echarts'
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'
import vSuggest from 'v-suggest'
import 'vue-suggestion/dist/vue-suggestion.css'
import 'echarts/dist/extension/dataTool.js'
import 'zrender/lib/svg/svg'
Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.echarts = echarts
Vue.use(vSuggest)
Vue.prototype.mydb = 'RBPs in TCGA'
Vue.prototype.axios.interceptors.request.use(config => {
  loadProgressBar()
  return config
})

// Vue.prototype.axios.interceptors.request.use(config => {
//   Loading.service({
//     fullscreen: true,
//     text: 'loading...'
//   })
//   return config
// })
//
// Vue.prototype.axios.interceptors.response.use(response => {
//   let loading = Loading.service({})
//   loading.close()
//   return response
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js